import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch, Model } from "vue-property-decorator";
import { getAllOperList } from "@/api/api-basic";
import { State } from "vuex-class";
let SelectOper = class SelectOper extends Vue {
    constructor() {
        super(...arguments);
        this.oprList = [];
        this.oprId = "";
    }
    getVisible() {
        this.oprId = this.oprPkId;
    }
    async getStation() {
        const ret = await getAllOperList({});
        if (ret.status === this.$config.apiStatus) {
            this.oprList = ret.data;
            this.$emit("success", this.oprList);
            if (this.oprId == "" && this.isFristChild && this.oprList[0]) {
                if (this.$config.defaultOprPkId) {
                    this.selectOper(this.$config.defaultOprPkId, "frist");
                }
                else {
                    this.selectOper(this.oprList[0].oprPkId, "frist");
                }
            }
        }
    }
    selectOper(val, type) {
        val = val == undefined ? "" : val;
        this.oprId = val;
        this.$emit("value", val);
        this.$emit("on-change", val, type);
    }
    created() {
        if (this.search && this.sys.userType !== "admin") {
            this.oprId = this.sys.operInfo.oprPkId;
            this.$emit("value", this.oprId);
            this.oprList = [
                {
                    oprPkId: this.sys.operInfo.oprPkId,
                    oprName: this.sys.operInfo.oprName,
                },
            ];
        }
        else {
            this.oprId = this.oprPkId;
            this.getStation();
        }
    }
};
__decorate([
    Prop({ default: "" })
], SelectOper.prototype, "width", void 0);
__decorate([
    Prop({ default: "" })
], SelectOper.prototype, "pkid", void 0);
__decorate([
    Prop({ default: "" })
], SelectOper.prototype, "transferClassName", void 0);
__decorate([
    Prop({ default: true })
], SelectOper.prototype, "search", void 0);
__decorate([
    Prop({ default: false })
], SelectOper.prototype, "isFristChild", void 0);
__decorate([
    Prop({ default: true })
], SelectOper.prototype, "clearable", void 0);
__decorate([
    Prop({ default: false })
], SelectOper.prototype, "disabled", void 0);
__decorate([
    Watch("oprPkId")
], SelectOper.prototype, "getVisible", null);
__decorate([
    Model("value", { type: String })
], SelectOper.prototype, "oprPkId", void 0);
__decorate([
    State("sys")
], SelectOper.prototype, "sys", void 0);
SelectOper = __decorate([
    Component
], SelectOper);
export default SelectOper;
